module.exports = __webpack_public_path__ + "static/media/institute-8-min.46f2aaec.webp";